// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"styles_gridWrapper__xRj1S","uploadBlock":"styles_uploadBlock___NS8F","icon":"styles_icon__lA3qz","gridBox":"styles_gridBox__X0X69","delete":"styles_delete__eAarG"};